import React from 'react';

import { Stack } from '@mui/material';
import { Header } from './components/Header';
import { ContentPage } from './components/ContentPage';
import { Footer } from './components/Footer';

import './NewFAQ.css';

export function NewFAQ() {
  return (
    <Stack>
      <Header />
      <ContentPage />
      <Footer />
    </Stack>
  );
}
